import { useGlobalStore } from "@/stores/global";
import { AiFeature } from "@/types/workspace";
import { hasAiFeature, isAiFeatureOn } from "@/utils/workspace";

/**
 * Whether admin picked `feature` for the current workspace, AI switch aside.
 * For the places that must stay reachable while AI is off - the studio, and
 * the settings that say "turn AI on first".
 */
export const useHasAiFeature = (feature: AiFeature): boolean =>
  useGlobalStore((state) => hasAiFeature(state.activeWorkspace, feature));

/** Whether an AI feature can be offered on the current workspace. */
export const useAiEnabled = (feature: AiFeature): boolean =>
  useGlobalStore((state) => isAiFeatureOn(state.activeWorkspace, feature));
